import { formatCurrency, preparePrice } from '../../helpers/utils'

function CartTotal({ cart }) {
    const totals = cart?.totals || {}
    let {
        total_items: subtotal,
        total_price: total,
        total_discount: discount,
    } = totals

    return (
        <>
            <div className="w-full flex flex-col gap-1 mb-6 pb-6 border-b border-gray-200">
                <div className="flex items-center justify-between w-full gap-2">
                    <span className="block truncate text-sm text-gray-500 text-left">
                        Subtotal
                    </span>
                    <span className="block truncate text-gray-800 font-semibold text-sm text-right">
                        {formatCurrency(preparePrice(subtotal), 2)}
                    </span>
                </div>
                <div className="flex items-center justify-between w-full gap-2">
                    <span className="block truncate text-sm text-gray-500 text-left">
                        Discount
                    </span>
                    <span className="block truncate text-olm font-semibold text-sm text-right">
                        {formatCurrency(preparePrice(discount), 2)}
                    </span>
                </div>
            </div>
            <div className="w-full flex flex-col gap-1 mb-6 pb-6 border-b border-gray-200">
                <div className="flex items-center justify-between w-full gap-2">
                    <span className="block truncate text-lg text-gray-800 font-semibold text-left">
                        Total
                    </span>
                    <span className="block truncate text-gray-800 font-semibold text-lg text-right">
                        {formatCurrency(preparePrice(total), 2)}
                    </span>
                </div>
            </div>
        </>
    )
}

export default CartTotal
